module.exports = __webpack_public_path__ + "media/images/eventapp-logo-7c014149.jpg";